import { useMutation } from '@tanstack/react-query'
import { syncPatientInterop } from '../../../data/patients'
import { UserFriendlyError } from '../../../model/Error'
import { addValid } from '../../../store/message'
import { useActionDispatch } from '../../utils'

export interface SyncPatientInteropMutateVariable {
  serial: string
}

export const useSyncPatientInterop = () => {
  const valid = useActionDispatch(addValid)

  return useMutation({
    mutationFn: async ({ serial }: SyncPatientInteropMutateVariable) => {
      const { ok, status, data } = await syncPatientInterop(serial)
      if (!ok) {
        if (status === 403) {
          throw new UserFriendlyError(
            'error',
            'Synchronisation non autorisée',
            "Vous n'êtes pas autorisé à synchroniser ce patient",
          )
        }
        // 422 : le back renvoie un `detail` explicite (champ(s) manquant(s) côté patient).
        throw new UserFriendlyError(
          'error',
          'La synchronisation du patient a échoué',
          data?.detail ?? `Une erreur technique s'est produite`,
        )
      }
      return null
    },
    onSuccess: () => {
      valid('Synchronisation du patient envoyée')
    },
  })
}
